import * as React from 'react';
import {
  NavItem,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Dropdown,
} from 'reactstrap';
import { INavBarActions } from '../hooks/useNavState';
import NavigationLink from './NavigationLink';
import { NavigationItem } from './NavigationItem';
import { isNavigationActive } from '../hooks/useIsRouteActive';
import { useNavBar } from 'src/modules/Routing/hooks/navBars/useNavBar';

interface IDesktopViewProps {
  toggleSettings: boolean;
  actions: INavBarActions;
}

const DesktopView: React.SFC<IDesktopViewProps> = (props) => {
  const { actions } = props;
  const [routes] = useNavBar();
  const isActive = isNavigationActive();
  return (
    <ul className="desktop-container">
      {routes.body.map((navModule, i) => (
        <NavigationLink
          key={navModule.module}
          isActive={isActive(navModule.route, i)}
          routePath={navModule.route}
          navTitle={navModule.module}
        />
      ))}
      <NavItem className="settings-dropdown">
        <Dropdown className="nav-link" isOpen={props.toggleSettings} toggle={actions.toggleSettings}>
          <DropdownToggle tag="span" className="fa fa-user-circle fa-2x" color="inherit" data-toggle="dropdown" aria-expanded={props.toggleSettings} />
          <DropdownToggle tag="span" className="fa fa-angle-down ml-1" color="inherit" data-toggle="dropdown" aria-expanded={props.toggleSettings} />
          <DropdownMenu>
            {routes.settings.map(navModule => (
              <NavigationItem
                key={navModule.module}
                isActive={isActive(navModule.route)}
                routePath={navModule.route}
                navTitle={navModule.module}
              />
            ))}
            <DropdownItem divider={true} />
            <DropdownItem onClick={actions.logout}><span className="fa fa-sign-out" aria-hidden="true" /> Logout </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </NavItem>
    </ul>
  );
};

export default React.memo(DesktopView);


// WEBPACK FOOTER //
// ./src/modules/Navigation/NavBar/components/DesktopView.tsx